<template>
  <div class="integrity">
    <div class="d-flex justify-content-end">
      <button
        class="ui-action-button"
        @click="save"
        :disabled="isUpdating"
      >
        {{$t('global.saveChanges')}}
        <b-spinner class="ml-1" small label="loading" v-if="isUpdating"></b-spinner>
      </button>
    </div>

    <div class="integrity__form">
      <div class="input-container">
        <label class="text-black">{{ $t("integrityCompliance.integrity.form_title") }} (*)</label>
        <input
          type="text"
          id="title"
          name="title"
          v-model="title"
        />
        <div class="ui-input-error-msg">
          <span v-if="$v.title.$error">{{ $t("global.inputs.required") }}</span>
        </div>
      </div>

      <div class="wysiwyg-container">
        <div class="wysiwyg">
          <Wysiwyg
            id="integrityDescription"
            ref="integrityDescription"
            :articleBody="descriptionCopy"
            :placeholder="$t('integrityCompliance.integrity.form_write_content')"
            :includeMediaContent="false"
            v-on:updateBody="description = $event"
          >
          </Wysiwyg>
          <div class="ui-input-error-msg">
            <span v-if="$v.description.$error">{{ $t("global.inputs.required") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const Wysiwyg = () => import("@/components/Wysiwyg");
import { required } from "vuelidate/lib/validators";
import { integrityComplianceKey } from "@/lib/constants.js";
import { validateBody } from '@/lib/utils.js'

import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

export default {
  inject: ['IC_getMainCategory'],
  components: {
    Wysiwyg
  },
  data: function() {
    return {
      id: null,
      title: '',
      description: {
        ops: []
      },
      descriptionCopy: {
        ops: []
      },
      isUpdating: false
    }
  },
  validations: {
    title: {
      required
    },
    description: {
      isRequired: function(data) {
        return validateBody(data)
      }
    }
  },
  mounted () {
    const mainCategory = this.IC_getMainCategory();
    this.id = mainCategory.id;
    this.title = mainCategory.title;
    this.description = mainCategory.description;
    this.descriptionCopy = mainCategory.description;
  },
  methods: {
    async save() {
      this.title = this.title.trim();
      this.$v.$touch();
      if (this.$v.$error) return;

      this.isUpdating = true;
      const params = {
        name: integrityComplianceKey.integrity,
        title: this.title,
        description: this.description
      }

      try {
        const response = await api.updateCategory(this.id, params);
        this.$emit('categoryUpdated', {
          id: this.id,
          ...response
        });

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('global.successSaved'),
          show: true,
          type: "success"
        });
      } catch(error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.integrity.error_intro'),
          show: true,
          type: "error"
        });
      } finally {
        this.isUpdating = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.integrity {
  width: 100%;
  &__form {
    margin-top: $global_padding;
    .input-container {
      width: 35%;
    }
    .wysiwyg-container {
      margin-top: $global_padding * 3
      ;
    }
  }
}
</style>
